import IconValueAndLabel from './IconValueAndLabel'

export default IconValueAndLabel
